import { useState, useEffect } from "react";

import { ExploreRelatedImage } from "@/types/thread";

const useExploreRelated = (
  generationId: number,
  initialImages: ExploreRelatedImage[],
  initialGenIds: number[]
) => {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState<ExploreRelatedImage[]>(initialImages);
  const [remainingGenIds, setRemainingGenIds] =
    useState<number[]>(initialGenIds);

  const fetchInitialGens = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/generation/related/${generationId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch related images");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMoreGens = async () => {
    if (remainingGenIds.length === 0) return;
    try {
      setLoading(true);
      const response = await fetch(
        `${
          process.env.NEXT_PUBLIC_API_URL
        }/generation?ids=${remainingGenIds.join(",")}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch related images");
      }
      const data = await response.json();
      const newImages = data.generations;
      setImages([...images, ...newImages]);
      setRemainingGenIds(data.remainingGenIds);
      setLoading(false);
      return data;
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (initialImages.length === 0) {
      fetchInitialGens()
        .then((data) => {
          setImages(data.generations);
          setRemainingGenIds(data.remainingGenIds);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          setImages([]);
          setRemainingGenIds([]);
        });
    }
  }, [generationId]);

  return { loading, images, remainingGenIds, fetchMoreGens };
};

export default useExploreRelated;
